var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "russia",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.3,
    height: 26,
    viewBox: "0 0 40.3 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M47.364,99.506V92.139a1.3,1.3,0,0,0-1.3-1.3H8.364l-.7,1.3v7.367l1.346,1.733h36.4Z",
    transform: "translate(-7.064 -90.839)",
    fill: "#f2f2f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M0,92.139v7.367l1.3,1.156V90.839A1.3,1.3,0,0,0,0,92.139Z",
    transform: "translate(0 -90.839)",
    fill: "#e1e1e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M7.817,290.765v6.8a1.3,1.3,0,0,0,1.3,1.3H46.2l1.3-.736v-7.367l-1.95-1.733H9.152Z",
    transform: "translate(-7.202 -273.432)",
    fill: "#e5646e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M1.3,301v-4.622L0,297.529V304.9a1.3,1.3,0,0,0,1.3,1.3H39a1.3,1.3,0,0,0,1.3-1.3H5.2A3.9,3.9,0,0,1,1.3,301Z",
    transform: "translate(0 -280.195)",
    fill: "#db4655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M8.667,208.507l.618,1.106h39v-8.667h-39l-.618,1.369Z",
    transform: "translate(-7.985 -192.279)",
    fill: "#5055a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M0,200.946H1.3v8.667H0Z",
    transform: "translate(0 -192.279)",
    fill: "#3f3f8f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRu);
export default __webpack_public_path__ + "static/media/ru.975e083b45054dc5cc7b56c884080242.svg";
export { ForwardRef as ReactComponent };